export default "__VITE_PUBLIC_ASSET__0bd66760__"